export const TYPES_COMMANDES = [
  { id: 1, label: 'BC', style: { color: '#007BC6', backgroundColor: '#007BC639' } },
  { id: 3, label: 'BL', style: { color: '#2A9D8F', backgroundColor: '#2A9D8F39' } },
  { id: 4, label: 'BR', style: { color: '#B5179E', backgroundColor: '#B5179E39' } },
  { id: 6, label: 'FA', style: { color: '#780000', backgroundColor: '#78000039' } },
  { id: 7, label: 'FC', style: { color: '#FFF', backgroundColor: 'fuchsia' } },
];

export const DEPOSITS = ['Bouskoura', 'Derb Omar', 'Ain Sebaa', 'Cfcim', 'Cfcim pro'];

export const DEPOSITS_O = [
  { id: 1, name: 'Bouskoura' },
  { id: 2, name: 'Derb Omar' },
  { id: 3, name: 'Ain Sbaa' },
  { id: 4, name: 'CFCIM Pro' },
  { id: 5, name: 'Diesel' },
  { id: 7, name: 'Poid Lourd' },
];

export const findDepositNameByCode = (code) => DEPOSITS_O.find((o) => o.id === code)?.name;
